exports.components = {
  "component---src-templates-structured-page-js": () => import("./../../../src/templates/structuredPage.js" /* webpackChunkName: "component---src-templates-structured-page-js" */)
}

